import { render, staticRenderFns } from "./Bing1.vue?vue&type=template&id=6041147a&scoped=true"
import script from "./Bing1.vue?vue&type=script&lang=js"
export * from "./Bing1.vue?vue&type=script&lang=js"
import style0 from "./Bing1.vue?vue&type=style&index=0&id=6041147a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6041147a",
  null
  
)

export default component.exports